import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { UserService } from '../../services/user.service';

@Component({
  template: '',
  selector: 'app-authentication-callback'
})
export class AuthenticationCallbackComponent implements OnInit {

  constructor(private authService: AuthenticationService, private userService: UserService, private router: Router) { }

  ngOnInit() {
      this.authService.completeAuthentication().then(user => {
        this.authService.storedUser.then(user => {
          this.userService.user = user;
          if ((Array.isArray(this.userService.getClaims().role) && this.userService.getClaims().role.includes('AEE_Admin')) || (typeof this.userService.getClaims().role === 'string' && this.userService.getClaims().role === 'AEE_Admin')){
            this.router.navigate(['sessions']);
          } else {
            this.router.navigate(['audits']);
          }
        });
      });
  }
}
